import api from '@utils/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import connectivitySlice from './connectivity.slice';
import { ConnectivityActionTypes } from './common.types';
function* handleFetchConnectivityData() {
    const connectivityData = yield call(api.getConnectivityData);
    yield put(connectivitySlice.actions.updateConnectivityData(connectivityData));
}
function* handleUpdateRegistryAddress(action) {
    yield put(connectivitySlice.actions.updateRegistry(action.payload));
}
function* handleUpdatePaymentMethod(action) {
    yield put(connectivitySlice.actions.updatePaymentMethod(action.payload));
}
function* handleUpdatePaymentData(action) {
    yield put(connectivitySlice.actions.updatePaymentData(action.payload));
}
function* watchFetchRequest() {
    yield takeEvery(ConnectivityActionTypes.FETCH_CONNECTIVITYDATA, handleFetchConnectivityData);
    yield takeEvery(ConnectivityActionTypes.UPDATE_REGISTRY, handleUpdateRegistryAddress);
    yield takeEvery(ConnectivityActionTypes.UPDATE_PAYMENTMETHOD, handleUpdatePaymentMethod);
    yield takeEvery(ConnectivityActionTypes.UPDATE_PAYMENTDATA, handleUpdatePaymentData);
}
export default function* connectivitySaga() {
    yield all([fork(watchFetchRequest)]);
}
